<template>
    <div class="page-container">
        <v-page-header title="登录安全" />
        <v-table
            :data="options"
            fixed-row-height
        >
            <v-table-column
                v-for="column in columns"
                :key="column.label"
                :column-key="column.columnKey"
                :label="column.label"
                :width="column.width"
            />
            <v-table-column
                :width="118"
                label="开启状态"
            >
                <template
                    slot="cell"
                    slot-scope="props"
                >
                    <div>
                        <v-tip
                            v-show="props.row.disabled"
                            ref="disabledTip"
                            placement="top"
                        >
                            该功能即将上线，敬请期待
                        </v-tip>
                        <v-switch
                            v-if="!props.row.disabled"
                            v-model="props.row.status"
                            :disabled="props.row.disabled"
                            :label="props.row.status ? '已开启' : '未开启'"
                            @click="click($event, props.row.id, props.row.status)"
                        />
                        <v-switch
                            v-else
                            v-model="props.row.status"
                            v-tip:disabledTip.hover
                            :disabled="props.row.disabled"
                            :label="props.row.status ? '已开启' : '未开启'"
                            @click="click($event, props.row.id, props.row.status)"
                        />
                    </div>
                </template>
            </v-table-column>
        </v-table>
        <v-dialog
            v-model="confirmDialog"
            kind="modal"
            confirm-text="确认开启"
            @confirm="confirm"
        >
            <div class="dialog-content">
                开启后，所有员工可使用绑定的手机号验证码登录，
                请确保所有员工绑定的都是本人的手机号，
                如要将账号转交给其他员工使用，注意更换绑定手机号
            </div>
        </v-dialog>
        <v-dialog
            v-model="deviceConfirmDialog"
            :title="deviceConfirmTitle"
            kind="confirm"
            confirm-text="确认"
            @confirm="deviceConfirm"
        >
            <div v-html="deviceConfirmContent" />
        </v-dialog>
    </div>
</template>

<script>

export default {
    data() {
        return {
            confirmDialog: false,
            options: [
                {
                    effect: '手机号登录',
                    desc: '开启后，所有员工可以使用手机号登录',
                    status: false,
                    hasConfirmDlg: true,
                    id: 'mobile',
                    disabled: false,
                    width: 140,
                },
                {
                    effect: '设备锁',
                    desc: '若开启设备锁，员工通过QQ登录时，需要使用移动端“企点APP”扫描二维码进行安全登录',
                    status: false,
                    hasConfirmDlg: true,
                    disabled: false,
                    id: 'device',
                },
            ],
            columns: [
                {
                    label: '功能',
                    columnKey: 'effect',
                    width: 116,
                },
                {
                    label: '描述',
                    columnKey: 'desc',
                },
            ],
            deviceConfirmDialog: false,
            deviceConfirmContent: '',
            deviceConfirmTitle: '',
        };
    },
    created() {
        this.getStatus();
    },
    methods: {
        click(event, id, curValue) {
            event.preventDefault();
            if (id === 'mobile') {
                if (!curValue) {
                    this.confirmDialog = true;
                } else {
                    this.setStatus();
                }
            } else if (id === 'device') {
                this.deviceConfirmDialog = true;
                this.deviceConfirmTitle = curValue ? '关闭设备锁' : '开启设备锁';
                this.deviceConfirmContent = curValue ? '关闭后，所有员工通过QQ账号和密码便可登录，<br>无需使用移动端“企点APP”扫描二维码进行安全登录' : '开启后，所有员工通过QQ登录时，均需使用移动端<br>“企点APP”扫描二维码进行安全登录';
            }
        },
        confirm() {
            this.setStatus();
        },
        setStatus() {
            this.$ajax.gatewayPost('/v1/basic.account.account_web.Account/SwitchUidLogin', {
                switch: String(this.options[0].status ? 0 : 1),
            })
                .then((res) => {
                    if (res && res.code === 0) {
                        this.$set(this.options[0], 'status', !this.options[0].status);
                        this.$message.success('设置成功');
                    } else {
                        this.$message.error(res.message || '设置失败');
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message || '设置失败');
                });
        },
        getStatus() {
            this.$ajax.gatewayPost('/v1/customer_defined_conf/get_conf', {
                useruin: 0,
                item_key: [
                    {
                        conf_key: 'mobile_login_whitelist',
                        version: 0,
                    },
                    {
                        conf_key: 'device_lock_switch',
                        version: 0,
                    },
                ],
            })
                .then((res) => {
                    if (res && res.code === 0) {
                        if (res.item_key && res.item_key.length && res.item_key[0] && Object.keys(res.item_key[0]).length > 1) {
                            const value = (res.item_key[0] && res.item_key[0].value) || false;
                            this.$set(this.options[0], 'status', Boolean(value === '0' ? 0 : 1));
                        } else {
                            this.$set(this.options[0], 'disabled', true);
                        }
                        // 设备锁开关判断，
                        if (res.item_key && res.item_key.length) {
                            const deviceLockConfig = res.item_key.find(item => Object.keys(item).length > 1 && item.conf_key === 'device_lock_switch');
                            if (deviceLockConfig) {
                                const value = (deviceLockConfig && deviceLockConfig.value) || false;
                                this.$set(this.options[1], 'status', Boolean(value === '0' ? 0 : 1));
                            }
                        }
                    } else {
                        this.$message.error(res.message || '接口请求失败');
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message || '接口请求失败');
                });
        },
        deviceConfirm() {
            this.$ajax.gatewayPost('/v1/customer_defined_conf/set_conf', {
                conf_key: 'device_lock_switch',
                value: String(this.options[1].status ? 0 : 1),
                useruin: 0,
            })
                .then((res) => {
                    if (res && res.code === 0) {
                        this.$set(this.options[1], 'status', !this.options[1].status);
                        this.$message.success('设置成功');
                    } else {
                        this.$message.error(res.message || '设置失败');
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message || '设置失败');
                });
        },
    },
};
</script>
<style scoped>
.dialog-content {
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    width: 400px;
}
/deep/ .v-table-body__tr {
    height: 110px;
}
</style>
